import React from 'react';
import { useShepherdTour } from './useShepherdTour';
import { TOUR_DATA } from './tourData';

const PredictionTour = ({ autoStart = true, onComplete  }) => {
  const { startTour } = useShepherdTour('prediction', TOUR_DATA.prediction.steps, autoStart, onComplete);

  return (
    <>
    {/* <button onClick={startTour} className="btn btn-primary mt-3">
      Start Prediction Tour
    </button> */}
    </>
  );
};

export default PredictionTour;
